module.exports = __webpack_public_path__ + "img/48.9c79d68d.jpg";